var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Store } from 'rxjs-observable-store';
import { UserProfileService } from '@services/user-profile.service';
import { AuthService } from '@services/auth.service';
import { tap } from 'rxjs/operators';
var UserRegistrationStore = /** @class */ (function (_super) {
    __extends(UserRegistrationStore, _super);
    function UserRegistrationStore(userProfileService, authService) {
        var _this = _super.call(this, {
            address: {}
        }) || this;
        _this.userProfileService = userProfileService;
        _this.authService = authService;
        return _this;
    }
    UserRegistrationStore.prototype.init = function () {
        var _this = this;
        var id = this.authService.getUserId();
        this.userProfileService.getUser(id).subscribe(function (res) { return _this.setState(res); });
    };
    UserRegistrationStore.prototype.submitUserProfile = function (userProfile) {
        var _this = this;
        return this.userProfileService
            .putUser(userProfile.id, __assign({}, userProfile))
            .pipe(tap(function () {
            _this.setState(__assign({}, userProfile));
            _this.authService.setUserHasCompletedDetails();
        }));
    };
    return UserRegistrationStore;
}(Store));
export { UserRegistrationStore };
